import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import SignatureEditor from "@/components/signatures/SignatureEditor";
import { PenLine } from "lucide-react";

// True when this user may manage their own signature (on by default for everyone;
// an admin can still remove it from a customised permission profile).
export function canManageOwnSignature(user) {
  if (!user) return false;
  if (user.role === "admin") return true;
  if (!Array.isArray(user.permissions)) return true;   // legacy account
  if (user.permissions.length === 0) return true;        // no custom profile yet
  return user.permissions.includes("manage_own_signature");
}

// A compact account-menu action (shown in every CRM's sidebar footer) that opens
// the My Signature editor dialog.
export default function MySignatureButton({ className = "" }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  if (!canManageOwnSignature(user)) return null;

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        title="My signature"
        aria-label="My signature"
        className={`p-2 rounded-full text-muted-foreground hover:text-foreground hover:bg-white/[0.06] transition-colors shrink-0 ${className}`}
        data-testid="my-signature-button"
      >
        <PenLine className="h-4 w-4" />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-xl max-h-[92vh] overflow-y-auto" data-testid="my-signature-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><PenLine className="h-5 w-5" />My signature</DialogTitle>
            <DialogDescription>Saved for auto-filling the authorized-representative line on documents you generate. Only you can set or change it.</DialogDescription>
          </DialogHeader>
          <SignatureEditor />
        </DialogContent>
      </Dialog>
    </>
  );
}
